(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sokkloft-product-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-product-form]').forEach((form) => {
    if (form.dataset.sokkloftReady === 'true') return;
    form.dataset.sokkloftReady = 'true';

    const variantsNode = form.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const groups = Array.from(form.querySelectorAll('[data-option-group]'));
    const variantId = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-add-to-cart]');
    const buttonLabel = form.querySelector('[data-add-to-cart-label]');
    const status = form.querySelector('[data-variant-status]');
    const selectionHint = form.querySelector('[data-selection-hint]');
    const section = form.closest('[data-product-section]');
    const price = section?.querySelector('[data-product-price]');
    const quantity = form.querySelector('input[name="quantity"]');
    const bundleButton = form.querySelector('[data-summer-bundle-add]');
    const bundleButtonLabel = form.querySelector('[data-summer-bundle-label]');
    const bundleStatus = form.querySelector('[data-summer-bundle-status]');
    const bundleValue = form.querySelector('[data-summer-bundle-value]');
    const bundleGroups = Array.from(form.querySelectorAll('[data-bundle-group]'));
    const purchaseModeButtons = Array.from(form.querySelectorAll('[data-purchase-mode]'));
    const purchaseModePanels = Array.from(form.querySelectorAll('[data-purchase-panel]'));

    if (variantId) variantId.disabled = false;

    const setPurchaseMode = (mode, focus = false) => {
      purchaseModeButtons.forEach((modeButton) => {
        const isActive = modeButton.dataset.purchaseMode === mode;
        modeButton.classList.toggle('is-active', isActive);
        modeButton.setAttribute('aria-selected', String(isActive));
        modeButton.tabIndex = isActive ? 0 : -1;
        if (isActive && focus) modeButton.focus();
      });
      purchaseModePanels.forEach((panel) => {
        panel.hidden = panel.dataset.purchasePanel !== mode;
      });
    };

    if (purchaseModeButtons.length > 0) {
      const requestedPurchaseMode = new URL(window.location.href).searchParams.has('variant')
        || new URL(window.location.href).searchParams.has('height')
        ? 'single'
        : 'bundle';
      setPurchaseMode(requestedPurchaseMode);

      purchaseModeButtons.forEach((modeButton, index) => {
        modeButton.addEventListener('click', () => setPurchaseMode(modeButton.dataset.purchaseMode));
        modeButton.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const offset = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = (index + offset + purchaseModeButtons.length) % purchaseModeButtons.length;
          setPurchaseMode(purchaseModeButtons[nextIndex].dataset.purchaseMode, true);
        });
      });
    }

    const readSelections = () => groups.map((group) => group.querySelector('[data-option-input]:checked')?.value || null);

    const updateVariant = () => {
      const selections = readSelections();
      const complete = selections.length > 0 && selections.every(Boolean);
      const variant = complete
        ? variants.find((candidate) => candidate.options.every((option, index) => option === selections[index]))
        : null;

      if (selectionHint) selectionHint.hidden = Boolean(variant);

      if (!variant) {
        if (variantId) variantId.value = '';
        if (button) button.disabled = true;
        if (buttonLabel) buttonLabel.textContent = button?.dataset.chooseLabel || '';
        if (status) status.textContent = '';
        return;
      }

      if (variantId) variantId.value = variant.id;
      if (price) price.textContent = variant.price;
      if (button) button.disabled = !variant.available;
      if (buttonLabel) buttonLabel.textContent = variant.available ? button.dataset.addLabel : button.dataset.soldOutLabel;
      if (status) status.textContent = variant.available ? variant.title : `${variant.title} – ${button.dataset.soldOutLabel}`;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.featured_media_id && section) {
        section.querySelectorAll('[data-media-id]').forEach((media) => {
          media.classList.toggle('is-variant-media', Number(media.dataset.mediaId) === Number(variant.featured_media_id));
        });
      }
    };

    const requestedHeight = new URL(window.location.href).searchParams.get('height');
    if (requestedHeight) {
      const heightGroup = groups.find((group) => group.dataset.optionName === 'hoyde');
      const requestedInput = heightGroup
        ? Array.from(heightGroup.querySelectorAll('[data-option-input]')).find((input) => input.value === requestedHeight)
        : null;
      if (requestedInput) requestedInput.checked = true;
    }

    form.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', updateVariant));
    form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = Number(quantity.value || 1) + 1;
    });

    const readBundleChoices = () => bundleGroups.map((group) => group.querySelector('[data-bundle-choice]:checked'));

    const updateBundleSelection = () => {
      if (!bundleButton) return;

      const choices = readBundleChoices();
      const complete = choices.length === 2 && choices.every(Boolean);
      bundleButton.disabled = !complete;

      if (!complete) {
        const hasAvailableChoice = form.querySelector('[data-bundle-choice]:not(:disabled)');
        if (bundleButtonLabel) {
          bundleButtonLabel.textContent = hasAvailableChoice
            ? bundleButton.dataset.addLabel || ''
            : bundleButton.dataset.unavailableLabel || '';
        }
        if (bundleValue) bundleValue.textContent = bundleValue.dataset.defaultValue || '';
        return;
      }

      const orderedChoices = choices.slice().sort((first, second) => Number(first.dataset.variantPrice) - Number(second.dataset.variantPrice));
      const savingsMoney = orderedChoices[0].dataset.variantPriceMoney || '';
      const priceMoney = orderedChoices[1].dataset.variantPriceMoney || '';
      const selectedTemplate = bundleValue?.dataset.selectedTemplate || '';

      if (bundleButtonLabel) bundleButtonLabel.textContent = bundleButton.dataset.readyLabel || '';
      if (bundleValue) {
        bundleValue.textContent = selectedTemplate
          .split('__PRICE__').join(priceMoney)
          .split('__SAVINGS__').join(savingsMoney);
      }
      if (bundleStatus) bundleStatus.textContent = '';
    };

    form.querySelectorAll('[data-bundle-choice]').forEach((input) => input.addEventListener('change', updateBundleSelection));

    bundleButton?.addEventListener('click', async () => {
      const choices = readBundleChoices();
      if (bundleButton.disabled || choices.length !== 2 || choices.some((choice) => !choice)) return;

      const defaultLabel = bundleButton.dataset.readyLabel || '';
      const errorLabel = bundleButton.dataset.errorLabel || '';
      const quantitiesByVariant = new Map();
      choices.forEach((choice) => {
        const variantId = Number(choice.value);
        quantitiesByVariant.set(variantId, (quantitiesByVariant.get(variantId) || 0) + 1);
      });
      const bundleItems = Array.from(quantitiesByVariant, ([id, itemQuantity]) => ({ id, quantity: itemQuantity }));
      bundleButton.disabled = true;
      bundleButton.setAttribute('aria-busy', 'true');
      if (bundleButtonLabel) bundleButtonLabel.textContent = bundleButton.dataset.addingLabel || defaultLabel;
      if (bundleStatus) bundleStatus.textContent = bundleButton.dataset.addingLabel || '';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: bundleItems
          })
        });

        if (!response.ok) throw new Error(errorLabel);

        if (bundleButtonLabel) bundleButtonLabel.textContent = bundleButton.dataset.addedLabel || defaultLabel;
        if (bundleStatus) bundleStatus.textContent = bundleButton.dataset.addedLabel || '';
        window.location.assign(`${root}cart`);
      } catch (error) {
        bundleButton.removeAttribute('aria-busy');
        updateBundleSelection();
        if (bundleButtonLabel) bundleButtonLabel.textContent = defaultLabel;
        if (bundleStatus) bundleStatus.textContent = errorLabel;
      }
    });

    if (groups.length > 0) updateVariant();
    updateBundleSelection();
  });
  } catch(e) { console.error(e); }
})();

})();
